var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"influencer-category-edit","toptitle":"Kategorie bearbeiten","title":_vm.influencerCategory.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-category-form',{attrs:{"influencerCategory":_vm.influencerCategory,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }